import React from 'react'
import PropTypes from 'prop-types'

import colors from '@settings/styleSettings'

import { Container, StatusBox } from './styles'

const PasswordIndicator = ({ check }) => {
  return (
    <Container>
      {check ? (
        <StatusBox style={{ backgroundColor: `${colors.strongGreen}1A` }}>
          <svg
            width="10"
            height="8"
            viewBox="0 0 10 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.54657 7.55636L0.165039 4.17476L1.01042 3.32935L3.54657 5.86556L8.98966 0.422363L9.83504 1.26776L3.54657 7.55636Z"
              fill={colors.primary}
            />
          </svg>
        </StatusBox>
      ) : (
        <StatusBox style={{ backgroundColor: `${colors.strongRed}1A` }}>
          <svg
            width="8"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.932039 7.83533L0.165039 7.06833L3.23304 4.00037L0.165039 0.932397L0.932039 0.165405L4.00004 3.23337L7.06804 0.165405L7.83504 0.932397L4.76704 4.00037L7.83504 7.06833L7.06804 7.83533L4.00004 4.76736L0.932039 7.83533Z"
              fill={colors.strongRed}
            />
          </svg>
        </StatusBox>
      )}
    </Container>
  )
}

PasswordIndicator.propTypes = {
  check: PropTypes.bool,
}

PasswordIndicator.defaultProps = {
  check: null,
}

export default PasswordIndicator
